import React from 'react';
import { Empty } from 'antd';
import NoDataImage from 'assets/images/dashboard/nodata_chart.svg';

const NoData = () => (
    <div className="no-data-container">
        <Empty
            image={NoDataImage}
            imageStyle={{ height: 300 }}
            description={<h4 style={{ color: "#273896" }}>Unable to retrieve data at the moment,<br />please contact support</h4>}
        />
    </div>
);

export default NoData;